import CT from '@marketplace-ai/tags';
import { useLocation, useNavigate } from 'react-router';
import type { ActorRefFrom } from 'xstate';
import { buildRegistrationPath, readRegistrationReturnTo } from '~/routing/registrationReturnTo';
import { paths } from '~/routing/routes';
import { Container, Footer, FormContent, Header } from '../components/Layout';
import { TYPE_CATEGORY_FORM_ID } from '../constants';
import { TypeCategoryNPIForm } from '../forms/TypeCategoryNPIForm';
import { providerRegistrationView } from '../registration-view.machine';
import type { RegistrationViewContext } from '../types';

interface PageProps {
  actorRef: ActorRefFrom<typeof providerRegistrationView>;
  viewContext: RegistrationViewContext;
}

const typeCategoryTags = CT.registration.typeAndCategory;
const footerTags = {
  back: typeCategoryTags.backButton,
  loadingBar: typeCategoryTags.loadingBar,
};

export function TypeCategoryPage({ actorRef, viewContext }: PageProps) {
  const navigate = useNavigate();
  const location = useLocation();

  const handleBack = () => {
    navigate(
      buildRegistrationPath(paths.register.roleSelect, readRegistrationReturnTo(location.search))
    );
  };

  return (
    <Container>
      <Header
        cyTag={typeCategoryTags.title}
        title="Tell us about yourself"
        subtitle="Please provide your professional information."
      />

      <FormContent>
        <TypeCategoryNPIForm actorRef={actorRef} viewContext={viewContext} />
      </FormContent>

      <Footer
        cyTags={footerTags}
        handleBack={handleBack}
        loadingPercent={25}
        next={{ formId: TYPE_CATEGORY_FORM_ID, cyTag: typeCategoryTags.nextButton }}
      />
    </Container>
  );
}
